<template>
    <div class="card-border">

        <div class="d-flex align-center">

            <v-icon large>{{data.icon}}</v-icon>
            <div>
                <h3 class="text-center">{{data.title}}</h3>
                <h1 class="text-center">{{data.value}}</h1>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "info-box",
        props: {
            data: {
                type: Number,
                default: ()=>{
                    return 0
                }
            }
        }
    }
</script>

<style scoped>

</style>